import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=d55f39a6&scoped=true"
import script from "./addTag.vue?vue&type=script&lang=js"
export * from "./addTag.vue?vue&type=script&lang=js"
import style0 from "./addTag.vue?vue&type=style&index=0&id=d55f39a6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55f39a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d55f39a6')) {
      api.createRecord('d55f39a6', component.options)
    } else {
      api.reload('d55f39a6', component.options)
    }
    module.hot.accept("./addTag.vue?vue&type=template&id=d55f39a6&scoped=true", function () {
      api.rerender('d55f39a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/tagManagement/addTag.vue"
export default component.exports